import { Component, OnInit, Input } from '@angular/core';
import { StoreService } from './../store.service'; 
import {FormControl} from '@angular/forms';
import { Router } from '@angular/router';

import {Observable} from 'rxjs/Observable';
import {startWith} from 'rxjs/operators/startWith';
import {map} from 'rxjs/operators/map';

import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-search-autocompl',
  templateUrl: './search-autocompl.component.html',
  styleUrls: ['./search-autocompl.component.css']
})
export class SearchAutocomplComponent  implements OnInit {

  stateCtrl: FormControl;
  filteredStates: Observable<any[]>;
  @Input() fontSize: string; 
  @Input() customClassPlaceholder: string; 
  @Input() customClassForm: string; 

  constructor( private $store : StoreService, private fb : FormBuilder,
                private router : Router ) {
    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this.filterStates(state) : this.$store.autocomplValues.slice())
      );
  }

  form1 : FormGroup;


  ngOnInit() {
    this.form1 = this.fb.group({
      level: ''
    })
  }

  filterStates(name: string) {
    return this.$store.autocomplValues.filter(state =>
      (state.name && state.name.toLowerCase().indexOf(name.toLowerCase()) === 0 
        || state.email && state.email.toLowerCase().indexOf(name.toLowerCase()) === 0)
        || state.type && state.type.toLowerCase().indexOf(name.toLowerCase()) === 0) 
  }



  test1(value) {
    this.$store.disabled = true
    this.$store.searchedSkills_inMemory = this.$store.searchedSkills
    this.$store.searchedSkills = []
    var foo = this.$store.autocomplValues.find(
      v => v.name === value
    )
    value = foo
    switch (value.valueType) {
      case "email": 
      if (this.$store.router.profile) {
        this.$store.getProfile(value.email)
        this.$store.router.params = null
      }
      else {
        this.$store.router = {
          profile : true, 
          params : value.email
        }
      }
      ; break
      case "skill": 
        this.$store.router = {
          profile: false, 
          params: null
        }
        this.$store.searchedSkills = [{ id : value.id, level : 1 }, { id : value.id, level : 2 }, { id : value.id, level : 3 }]
        this.$store.searchedSkills_array = []
        this.$store.searchedSkills_object = this.$store.searchedSkills.reduce(function (r, a) {
            r[a.id] = r[a.id] || [];
            r[a.id].push(a);
            return r;
        }, Object.create(null));
        this.$store.searchedSkills_array = Object.entries(this.$store.searchedSkills_object)
        if (this.router.url !== "/"){
          this.$store.resetSearchedSkills = false; 
          this.router.navigate([''])
        }; break
        case "family": 
        this.$store.router = {
          profile: false, 
          params: null
        }
        var x = this.$store.skills.find(s => s.type === value.type)
        var y = x.categories.find(c => c.category === value.name)
        var idArray = []
        y.skills.forEach(
          a => this.$store.searchedSkills.push({id: a.id, level: 1}, {id: a.id, level: 2}, {id: a.id, level: 3})
        )
        this.$store.searchedSkills_array = []
        this.$store.searchedSkills_object = this.$store.searchedSkills.reduce(function (r, a) {
            r[a.id] = r[a.id] || [];
            r[a.id].push(a);
            return r;
        }, Object.create(null));
        this.$store.searchedSkills_array = Object.entries(this.$store.searchedSkills_object)
        this.$store.searchedSkills_array.unshift("else")
        if (this.router.url !== "/"){
          this.$store.resetSearchedSkills = false; 
          this.router.navigate([''])
        }; break
          
    }
  }

  test2(value) {
    this.$store.disabled = true
    console.log(value)
    var query = this.$store.autocomplValues.find(
      el => el.name === value
    )
    console.log('ob', query); 
    if (query.email !== undefined) {
      console.log('Email', query.email)
      this.router.navigate([`profile/${query.email}`])
    }
    else {
      console.log('no email', this.router.url)
      this.$store.searchedSkills_inMemory = this.$store.searchedSkills
      console.log('this.$store.searchedSkills_inMemory', this.$store.searchedSkills_inMemory)
      this.$store.searchedSkills = [{ id : query.id, level : 1 }, { id : query.id, level : 2 }, { id : query.id, level : 3 }]
      this.$store.searchedSkills_array = []
      this.$store.searchedSkills_object = this.$store.searchedSkills.reduce(function (r, a) {
          r[a.id] = r[a.id] || [];
          r[a.id].push(a);
          return r;
      }, Object.create(null));
      this.$store.searchedSkills_array = Object.entries(this.$store.searchedSkills_object)
      
      if (this.router.url !== "/"){
        this.$store.resetSearchedSkills = false; 
        this.router.navigate([''])
      }
      
    }
    console.log('NEW STORE S', this.$store.searchedSkills)
    }
}
 




// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/search-autocompl/search-autocompl.component.ts